import DynamicEditForm from '../DynamicEditForm';
import ModalLoading from '../Modal/ModalLoading';
import useQueryEffect from '/src/hooks/useQueryEffect';
import {useUpdatePlotMutation} from '/src/redux/plotsApi';
import {useGetPlotQuery} from '/src/redux/plotsApi';
import LoadingSpinner from '../LoadingSpinner';
import { useEffect, useState } from 'react';
import ModalError from '../Modal/ModalError';

const formConfig = {
    autoFocus: true,
    inline: true,
    saveText: 'Save',
    discardText: '⭯',
    showSaveOnDirty: true,
    fields: [
        {
            key: 'date',
            title: 'Purchase Date',
            type: 'date',
            placeholder: 'MM/DD/YYYY',
            max:'9999-12-31',
            required: false,
        },
    ],
}

export default function MapEditorDateEditor({_id}){
    const { data: details, error: queryError, isLoading } = useGetPlotQuery(_id, {skip: !_id});
    const [updatePlot, { error: mutationError, isLoading: isUpdating, isSuccess: isUpdateSuccess }] = useUpdatePlotMutation();
    const [error, setError] = useState(null);

    const userTookAction = useQueryEffect((error)=>{
        if(error){
            setError(error);
        }else{
            // success
        }
    }, [isUpdateSuccess], [mutationError]);

    function onSaveDateForm(data){
        userTookAction();
        updatePlot({
            ...data,
            _id: _id,
        });
    }

    return (
        <div>
            {isUpdating && <ModalLoading title='Saving' absolute={true} />}
            {error && <ModalError message={error.message} callback={()=>setError(null)} />}
            {(queryError && (
                <Alert className="border-t-red-600"><p>Failed to load.</p></Alert>
            )) || (isLoading && (
                <LoadingSpinner className='w-6' />
            )) || (
                <DynamicEditForm formConfig={formConfig} selectedAsset={details || null} onSave={data=>onSaveDateForm(data)} />
            )}
        </div>
    )
}